import { AccountService } from 'data/service/account-service';
import { autoinject, LogManager, bindable } from 'aurelia-framework';

@autoinject
export class IsInRoleValueConverter {

	constructor(private accountService: AccountService) {}

	toView(value: string, role: string) {

		if (this.accountService.currentUser.appRoles.indexOf(role) > -1)
			return true;

		return false;
	}
}